import {
  Group, Mesh, SphereGeometry, MeshBasicMaterial, Vector3,
  TubeGeometry, CatmullRomCurve3, AdditiveBlending,
} from "three";
import type { Chapter } from "./index";

export function createCh1Weak(): Chapter {
  const group = new Group();

  const neutron = new Mesh(
    new SphereGeometry(0.6, 24, 24),
    new MeshBasicMaterial({ color: 0xff8c66, transparent: true, opacity: 0.4 }),
  );
  group.add(neutron);

  const wTrail = new Mesh(
    new TubeGeometry(new CatmullRomCurve3([
      new Vector3(0, 0, 0), new Vector3(0.6, 0.3, 0.2), new Vector3(1.2, 0.5, 0.5),
    ]), 24, 0.05, 8, false),
    new MeshBasicMaterial({ color: 0xfff066, transparent: true, opacity: 0, blending: AdditiveBlending }),
  );
  group.add(wTrail);

  const electron = new Mesh(
    new SphereGeometry(0.08, 12, 12),
    new MeshBasicMaterial({ color: 0x88aaff }),
  );
  electron.visible = false;
  group.add(electron);

  const neutrino = new Mesh(
    new SphereGeometry(0.05, 8, 8),
    new MeshBasicMaterial({ color: 0xaaffaa, transparent: true, opacity: 0.5 }),
  );
  neutrino.visible = false;
  group.add(neutrino);

  group.visible = false;

  return {
    id: 1,
    enter(ctx) { ctx.scene.add(group); group.visible = true; },
    exit(_ctx) { group.visible = false; },
    update(_ctx, _t, _dt, local) {
      neutron.rotation.y = local * Math.PI;
      const wT = Math.max(0, (local - 0.3) / 0.4);
      (wTrail.material as MeshBasicMaterial).opacity = Math.min(1, wT) * 0.9;
      const decayT = Math.max(0, (local - 0.5) / 0.5);
      electron.visible = decayT > 0;
      neutrino.visible = decayT > 0;
      electron.position.set(1.5 + decayT * 2, 0.4, 0.6);
      neutrino.position.set(1.4 + decayT * 2.4, 0.7, -0.2);
    },
  };
}
